import { useContext } from 'react';
import { QuoteSpecifications } from '../../../../store/redux/slices/offersSlice';
import { SingleOfferStateContext } from './SingleOfferStateProvider';

interface UseQuoteSpecs {
  quoteSpecs: QuoteSpecifications;
  setQuoteSpecs: (quoteSpecs: QuoteSpecifications) => void;
}

const useQuoteSpecs = (): UseQuoteSpecs => {
  const singleOfferState = useContext(SingleOfferStateContext);

  return {
    quoteSpecs: singleOfferState?.quoteSpecs ? singleOfferState.quoteSpecs : {},
    setQuoteSpecs: singleOfferState?.setQuoteSpecs
      ? singleOfferState.setQuoteSpecs
      : () => null,
  };
};

export default useQuoteSpecs;
